import '../../stylesheets/pdf.scss'
import {onDocumentReady} from '../render/utils'

import PDFViewer from './lib'

onDocumentReady(PDFViewer)
